import { useEffect, useState } from "react";
import { clamp, rafThrottle } from "../lib/motion";

/**
 * Scroll-derived UI state from a single rAF-throttled listener.
 *
 * Replaces the old useScrollPosition hook, which re-rendered the navbar on
 * every scroll event because it stored the raw pixel offset in state.
 */
export default function useScrollState() {
  const [state, setState] = useState({ scrolled: false, progress: 0 });

  useEffect(() => {
    const read = () => {
      const y = window.scrollY || 0;
      const max = document.documentElement.scrollHeight - window.innerHeight;

      setState((prev) => {
        const next = {
          scrolled: y > 24,
          progress: max > 0 ? clamp(y / max, 0, 1) : 0,
        };
        if (
          prev.scrolled === next.scrolled &&
          Math.abs(prev.progress - next.progress) < 0.002
        ) {
          return prev;
        }
        return next;
      });
    };

    const onScroll = rafThrottle(read);
    read();

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return state;
}
